import { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'ypf-pas-general-ui-components';

import { formatDate } from '../../../utils/formatUtils';
import LoaderContext from '../../../context/LoaderProvider';
import { postTemplateGrid } from '../../../services/templateWorkReport';
import useToast from '../../../hooks/useToast';

const TemplateWorkReport = ({
  checkBoxState,
  contractNumber,
  goForceReset,
  isMonthly,
  itemCheck,
  newFetch,
  setCheckBoxState,
  setItemCheck,
  viewWithOutCheckBox,
  withAmount
}) => {
  const [dataTemplate, setdataTemplate] = useState([]);
  const [paginationState] = useState({
    pageIndex: 0,
    pageSize: 5,
    sortBy: []
  });
  const [totalPages, setTotalPages] = useState(1);
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const handleChangeSelect = (item) => {
    if (checkBoxState.includes(item)) {
      const newSelect = checkBoxState.filter((name) => name !== item);

      setCheckBoxState(newSelect);
      const newItem = itemCheck.filter(
        (itemTemplate) =>
          itemTemplate.nombrePlantilla !== dataTemplate[Number(item)].nombrePlantilla
      );

      setItemCheck(newItem);

      return;
    }

    setItemCheck([...itemCheck, dataTemplate[Number(item)]]);
    setCheckBoxState([...checkBoxState, item]);
  };

  const styleCell = ({ value }) => (
    <div
      className="row justify-content-center"
      style={{
        textAlign: 'center',
        display: 'flex'
      }}
    >
      {!value ? '-' : value}
    </div>
  );

  const columnsTable = [
    {
      Header: '',
      accessor: 'checkbox',
      hideSort: true,
      Cell: (cell) => {
        const {
          row: { id }
        } = cell;

        return (
          <div
            style={{
              textAlign: 'center',
              display: 'flex',
              width: '.5px'
            }}
          >
            <input
              defaultChecked={checkBoxState.includes(id)}
              onChange={() => handleChangeSelect(id)}
              type="checkbox"
              value={undefined}
            />
          </div>
        );
      }
    },
    {
      Header: 'Nombre',
      accessor: 'nombrePlantilla',
      hideSort: true
    },
    {
      Header: 'N° Contrato',
      accessor: 'numeroContrato',
      hideSort: true,
      style: {
        fontWeight: '600',
        width: '180px'
      }
    },
    {
      Header: 'On Call',
      accessor: 'cantidadOnCall',
      hideSort: true,
      style: {
        width: '90px'
      },
      Cell: styleCell
    },
    {
      Header: 'Mensualizadas',
      accessor: 'cantidadMensualizada',
      hideSort: true,
      style: {
        width: '120px'
      },
      Cell: styleCell
    },
    {
      Header: 'Creadas el',
      accessor: 'fechaCreacion',
      hideSort: true,
      style: {
        width: '120px'
      },
      Cell: formatDate
    },
    {
      Header: 'N° Ubi.',
      accessor: 'cantidadUbicaciones',
      hideSort: true,
      style: {
        width: '120px'
      },
      Cell: styleCell
    }
  ];

  const columnsAux = [...columnsTable];

  const templateWorkReportMapper = (templatesWR) =>
    templatesWR?.map((templateWR) => ({
      id: templateWR.id,
      numeroContrato: templateWR.numeroContrato,
      fechaCreacion: templateWR.fechaCreacion,
      nombrePlantilla: templateWR.nombrePlantilla,
      cantidadMensualizada: templateWR.cantidadMensualizada,
      cantidadOnCall: templateWR.cantidadOnCall,
      cantidadUbicaciones: templateWR.cantidadUbicaciones
    }));

  const fetchDataTemplate = async ({ pageIndex, pageSize }) => {
    try {
      setLoader(true);
      const response = await postTemplateGrid({
        numeroContrato: contractNumber,
        esMensualizada: isMonthly,
        paginacion: {
          skip: pageIndex + 1,
          pageSize: pageSize ?? 5
        },
        conCantidad: withAmount
      });

      const mappedTemplatesWR = templateWorkReportMapper(response.items);

      setdataTemplate(mappedTemplatesWR);
      setCheckBoxState([]);
      setItemCheck([]);

      setTotalPages(response?.totalPages);
      setLoader(false);
    } catch (err) {
      setNewToast({
        Type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!viewWithOutCheckBox) {
      setItemCheck([]);
      setCheckBoxState([]);
      setLoader(true);
      fetchDataTemplate({
        pageIndex: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFetch, withAmount]);

  useEffect(() => {
    if (viewWithOutCheckBox) {
      setdataTemplate([]);
      const mappedSelectItem = templateWorkReportMapper(itemCheck);

      setdataTemplate(mappedSelectItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewWithOutCheckBox]);

  return (
    <>
      {dataTemplate?.length > 0 && (
        <Table
          cantFiles={[5, 10, 20, 30]}
          columns={viewWithOutCheckBox ? columnsAux : columnsTable}
          data={dataTemplate}
          fetchData={fetchDataTemplate}
          goForceReset={goForceReset}
          initialState={{
            pageIndex: paginationState.pageIndex,
            pageSize: paginationState.pageSize,
            sortBy: paginationState.sortBy
          }}
          pageCount={totalPages}
          pagination={!viewWithOutCheckBox}
          titleLeft
          type="light"
        />
      )}
    </>
  );
};

TemplateWorkReport.propTypes = {
  checkBoxState: PropTypes.arrayOf(PropTypes.number),
  contractNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  goForceReset: PropTypes.shape({ current: PropTypes.func }),
  isMonthly: PropTypes.bool.isRequired,
  itemCheck: PropTypes.arrayOf(PropTypes.shape({})),
  newFetch: PropTypes.bool,
  setCheckBoxState: PropTypes.func,
  setItemCheck: PropTypes.func,
  viewWithOutCheckBox: PropTypes.bool,
  withAmount: PropTypes.bool
};

TemplateWorkReport.defaultProps = {
  checkBoxState: [],
  goForceReset: {},
  itemCheck: [],
  newFetch: false,
  setCheckBoxState: () => {},
  setItemCheck: () => {},
  viewWithOutCheckBox: false,
  withAmount: false
};

export default TemplateWorkReport;
